export default __webpack_public_path__ + "static/GilroyBold-164bd8331c266f9df722e6843c810f2e.woff";